import { useSelector } from 'react-redux'
import {
  CargoItemInterface,
  SlotItemInterface,
  TransportItemInterface,
} from '../../types/interfaces'
import classes from './StatusComponent.module.sass'
import { selectCurrentUser } from '../../../store/slices/currentUserSlice'
import { orderStatusToText } from '../../utils/functions/enumToText'
import { Status } from '../../types/enums'

type Props = {
  item: TransportItemInterface | CargoItemInterface | SlotItemInterface
}

export const StatusComponent = ({ item }: Props) => {
  const currentUser = useSelector(selectCurrentUser)
  if (item.status || item.status === 0)
    return (
      <div className={classes.Container}>
        {item.userId === currentUser?.id && item.status === Status.NEW
          ? 'Опубликован'
          : item.executorId === currentUser?.id && item.status === Status.IN_WORK
          ? 'в работе у вас'
          : orderStatusToText(item.status)}
      </div>
    )
}
